import xmlFormatter from "xml-formatter";

export function formatXml(data) {
  try {
    return xmlFormatter(data, { indentation: "  " });
  } catch (error) {
    console.error("XML formatting error:", error);
    return data;
  }
}
